import { render, staticRenderFns } from "./ViewVehicle.vue?vue&type=template&id=2bbf6be0&scoped=true"
import script from "./ViewVehicle.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewVehicle.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbf6be0",
  null
  
)

export default component.exports